import { formatIsoDate, type DateInput } from "@/utils/date-format";

const YMD_PREFIX = /^(\d{4}-\d{2}-\d{2})/;

/** UTC calendar `YYYY-MM-DD` for `@db.Date` hall / raza event comparison. */
export function toUtcYmd(value: DateInput): string | null {
  if (value == null || value === "") return null;
  if (typeof value === "string") {
    const match = YMD_PREFIX.exec(value.trim());
    if (match) return match[1];
  }
  // Date / Dayjs / number: format in UTC so `@db.Date` midnight does not shift locally.
  const ymd = formatIsoDate(value, { utc: true, empty: "" });
  return ymd || null;
}

/** True when hall slot and raza event fall on the same UTC calendar day. */
export function hallSlotMatchesRazaEventDate(hallDate: DateInput, eventDate: DateInput): boolean {
  const hallYmd = toUtcYmd(hallDate);
  const eventYmd = toUtcYmd(eventDate);
  if (!hallYmd || !eventYmd) return false;
  return hallYmd === eventYmd;
}
